export default class DtoBoreholeDrilling {
    constructor(obj) {
        this.idStation = obj.idStation
        this.order = obj.order
        this.diameter = obj.diameter
        this.depth = obj.depth
        this.comment = obj.comment
        this.headers = ['order', 'diameter', 'depth', 'comment']
    }
}